import { Injectable } from '@angular/core';
import { ApiService } from "../api.service";

@Injectable({
  providedIn: 'root'
})
export class FeatureHandlerService {

  constructor(private ApiService: ApiService) {}

  getAll() {
    return this.ApiService.get('features');
  }

}
